import React from 'react'
import MuiAppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import logoUrl from '../../assets/floodnet_logo_bw_5in.png'
import { Box } from '@mui/material'

const LogoAndName = React.memo(({ onClick }: { onClick?: () => void }) => (
  <Box onClick={onClick} sx={{ display: 'flex', alignItems: 'center', cursor: onClick ? 'pointer' : 'default' }}>
    <img src={logoUrl} alt="FloodNet Logo" style={{ height: 32, verticalAlign: 'middle' }} />
    <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 700, display: { xs: 'none', sm: 'block' }, p: 1 }}>
      FloodNet NYC
    </Typography>
  </Box>
))

export default function AppBar({ children, goToHome }: { children?: React.ReactNode; goToHome?: () => void }) {
  return (
    <MuiAppBar 
      // position='sticky' 
      position='absolute'
      elevation={6} 
      color='default'
      sx={{ 
        position: { xs: 'fixed', sm: 'fixed' },
        // backdropFilter: 'blur(1px)', 
        // bgcolor: 'background.paper',
        // bgcolor: 'transparent',
        maxWidth: '100vw',
        top: 0, left: 0, right: 0,
        zIndex: 20,
        py: 0,
      }}>
      <Toolbar sx={{ gap: 0.5, minHeight: '48px !important' }}>
        <LogoAndName onClick={goToHome} />
        {children}
      </Toolbar>
    </MuiAppBar>
  )
}
